import React from 'react';
import { xconnect } from '../../redux/xconnect';
import { initAppSettings } from '../home/Elements';
import {
  isPinCodeRequired,
  isPinCodeWrong,
  isRequestFirstLoaded,
  isRequestReadyToStart
} from '../home/utils';
import PropTypes from 'prop-types';
import {
  gaAlreadySubmitted,
  gaCheckPinCode,
  gaNavigateToList,
  gaPropsToGAEvent
} from '../home/ga';
import { f7navigator } from './navigator';
import { setScanStarted } from '../../redux/actions/rootAction';
import { withSpan } from '../../telemetry/tracing';

export const STARTED_FROM_URL = 1;
export const STARTED_FROM_QR = 2;

export default function withAppStart(WrappedComponent) {
  // noinspection JSPotentiallyInvalidUsageOfThis
  class withAppStartWrapper extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        //checkPasswordMode: false,
        checkSMSMode: false,
        requestReadyToStart: false
      };
    }

    componentDidMount() {
      if (
        (isRequestFirstLoaded(this.props) &&
          isRequestReadyToStart(this.props)) ||
        this.props.authOnStartRequired
      ) {
        this.doOnAppReadyToStart();
      }

      if (isRequestReadyToStart(this.props)) {
        if (this.props.skipStartPage && !this.props.submitted) {
          setTimeout(this.startScan, 50);
        }
      }

      if (this.props.submitted && !this.props.authOnStartRequired) {
        gaAlreadySubmitted();
        gaNavigateToList(false);

        setTimeout(
          () =>
            f7navigator.toList(
              {},
              {
                ignoreCache: true,
                pushState: false,
                animate: false
              },
              true
            ),
          50
        );
      }
    }

    doOnAppReadyToStart() {
      initAppSettings({
        skipStartPage: this.props.skipStartPage,
        skipListMode: this.props.isSkipDocumentListMode,
        crossDeviceMode: this.props.crossDeviceRequest != null,
        onBrowserBack: () => this.props.navigateBack(),
        analyticsDisabled: this.props.analyticsDisabled,
        caseName: this.props.caseName,
        companyName: this.props.companyName,
        queryRequestId: this.props.recipientRequestId,
        f7: this.$f7,
        f7router: this.$f7router,
        templateMode: this.props.templateMode,
        scanEnded: this.props.scanEnded,
        brandingDetails: this.props.brandingDetails
      });
    }

    /*showPasswordAlertDialog = () => {
      this.$f7.dialog.password(
        getCasePasswordHint(this.props),
        II18.get('home_password_required'),
        password => {
          this.setState({
            checkPasswordMode: true
          });
          this.$f7.dialog.preloader(II18.get('home_password_verification'));
          this.props.listRequestedDocuments(
            this.props.recipientRequestId,
            md5Password(password)
          );
        }
      );
    };*/

    componentDidUpdate(prevProps) {
      gaPropsToGAEvent(this.props);

      /*if (this.state.checkPasswordMode) {
        if (isPasswordWrong(this.props)) {
          this.$f7.dialog.alert(
            II18.get('home_password_wrong'),
            this.showPasswordAlertDialog
          );
          return;
        }
        if (isRequestedDocumentsFirstLoaded()) {
          this.$f7.dialog.close();
          this.startScan();
        }
      }*/

      if (isRequestFirstLoaded(this.props, prevProps)) {
        this.doOnAppReadyToStart();
        if (this.state.checkSMSMode || this.props.skipStartPage) {
          setTimeout(this.startScan, 500);
        }
      }
    }

    startScan = () => {
      /*if (isCasePasswordRequired(this.props)) {
        this.showPasswordAlertDialog();
        return;
      }*/

      if (this.props.authOnStartRequired) {
        this.setState({
          checkSMSMode: true
        });
        return;
      }

      if (!this.props.scanStarted) {
        this.props.setScanStarted(
          this.props.startedFromQR ? STARTED_FROM_QR : STARTED_FROM_URL
        );
      }

      this.props.navigateToRequestStart(
        this.props.skipStartPage || window.isDesktop
      );
    };

    verifyPinCode = code => {
      if (code) {
        gaCheckPinCode();
        window.lastPinCode = code;
        return withSpan(
          'auth.pin',
          { 'auth.method': 'pin', 'auth.step': 'verify' },
          () =>
            this.props.listRequestedDocuments(
              this.props.recipientRequestId,
              code
            )
        );
      }
    };

    onCheckSMSDone = otpRequestId => {
      this.props.listRequestedDocuments(this.props.recipientRequestId, {
        otpRequestId: otpRequestId,
        pin: window.lastPinCode
      });
    };

    render() {
      const { infoMessage, errorMessage, authOnStartRequired } = this.props;
      return (
        <>
          <WrappedComponent
            receivedAdditionalInfoOrError={Boolean(
              errorMessage || infoMessage || authOnStartRequired
            )}
            showPinIsWrongMessage={isPinCodeWrong(this.props)}
            pinRequired={isPinCodeRequired(this.props)}
            verifyPinCode={this.verifyPinCode}
            onCheckSMSDone={this.onCheckSMSDone}
            checkSMSMode={this.state.checkSMSMode}
            startScan={this.startScan}
            {...this.props}
          />
        </>
      );
    }
  }

  withAppStartWrapper.propTypes = {
    startedFromQR: PropTypes.bool,
    selectedLang: PropTypes.string,
    isSkipDocumentListMode: PropTypes.bool,
    analyticsDisabled: PropTypes.bool,
    brandingDetails: PropTypes.object,
    caseName: PropTypes.string,
    closed: PropTypes.bool,
    companyEmail: PropTypes.string,
    companyName: PropTypes.string,
    emailMessage: PropTypes.string,
    endDate: PropTypes.string,
    errorCode: PropTypes.string,
    errorMessage: PropTypes.string,
    isFetching: PropTypes.bool,
    listRequestedDocuments: PropTypes.func,
    navigateToMobileDocument: PropTypes.func,
    oneDocumentMode: PropTypes.bool,
    recipientRequestId: PropTypes.string,
    requestMessage: PropTypes.string,
    infoMessage: PropTypes.string,

    scanEnded: PropTypes.bool,
    scanStarted: PropTypes.any,
    setScanStarted: PropTypes.func,
    submitted: PropTypes.bool,
    templateMode: PropTypes.bool,
    authOnStartRequired: PropTypes.bool,
    skipStartPage: PropTypes.bool,
    crossDeviceRequest: PropTypes.object,
    navigateBack: PropTypes.func,
    navigateToRequestStart: PropTypes.func,
    requestPages: PropTypes.any,
    requestedDocuments: PropTypes.array,
    rawRequestPages: PropTypes.any,
    rawRequestedDocuments: PropTypes.array,

    //withDocumentRootLogic
    navigateToDesktopDocument: PropTypes.func
  };

  const mapStateToProps = state => {
    return {
      scanStarted: state.scanStarted,
      analyticsDisabled: state.analyticsDisabled
    };
  };

  const mapDispatchToProps = dispatch => ({
    setScanStarted: startedFrom => dispatch(setScanStarted(startedFrom))
  });

  return xconnect(mapStateToProps, mapDispatchToProps)(withAppStartWrapper);
}
